import { render, staticRenderFns } from "./specialGoodsOrderDetail.vue?vue&type=template&id=10b82bfe&"
import script from "./specialGoodsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./specialGoodsOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./specialGoodsOrderDetail.vue?vue&type=style&index=0&id=10b82bfe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports